import styled from '@emotion/styled';

export const Timeline = () => {
  return (
    <S.Timeline>
      <div>0:00</div>
      <div>1:00</div>
      <div>2:00</div>
      <div>3:00</div>
      <div>4:00</div>
      <div>5:00</div>
      <div>6:00</div>
      <div>7:00</div>
      <div>8:00</div>
      <div>9:00</div>
      <div>10:00</div>
      <div>11:00</div>
      <div>12:00</div>
      <div>13:00</div>
      <div>14:00</div>
      <div>15:00</div>
      <div>16:00</div>
      <div>17:00</div>
      <div>18:00</div>
      <div>19:00</div>
      <div>20:00</div>
      <div>21:00</div>
      <div>22:00</div>
      <div>23:00</div>
    </S.Timeline>
  );
};

const S = {
  Timeline: styled.div`
    display: grid;
    grid-template-columns: repeat(24, minmax(90px, 1fr));
    height: 100%;
    align-items: center;
    & > div {
      font-size: 12px;
      padding: 0 4px;
      border-left: solid 1px #ddd;
    }
  `,
};
